export const PermissionAdministrator = {
    PUT: "change_user",
    VIEW: "view_user",
    POST: "add_user",
    DELETE: "delete_user",
    EXPORT: "can_export_user",
};